/* istanbul ignore file */
import { DropDownFilter, BaseFilterProps } from 'framework/list';
import React from 'react';
import ExpenseStatusDropdown from 'domain/finance/expenses/shared/input/ExpenseStatusDropdown';

const ExpenseStatusFilter = ({ source, ...props }: BaseFilterProps & { label: string }) => {
  return (
    <DropDownFilter {...props} source={source}>
      <ExpenseStatusDropdown source={source} />
    </DropDownFilter>
  );
};

export default ExpenseStatusFilter;
